<div class="d-flex align-items-start">
  <div class="d-flex mr-3 icon-container">
    <fa-icon [icon]="['fas', 'store']"></fa-icon>
  </div>
  <div>
    <epc-account-details
      [account]="account"
      class="d-block mb-1"
    ></epc-account-details>
    @if (accountAddresses$ | async; as addresses) {
    <ul>
      @for (address of addresses; track address) {
      <li class="text-muted" data-e2e="selected-address">
        <span class="ml-1">{{address | concatenatedFields : {
            fields: (addressFields$ | async),
            separator: ' &#45; ',
            }
        }}</span>
      </li>
      }
    </ul>
    }
  </div>
</div>
